<template>
  <div>
    <h1>Add Counselor</h1>
    <form @submit.prevent="submitForm">
      <label for="name">Name:</label>
      <input type="text" id="name" v-model="name" required>
      
      <label for="university">University:</label>
      <input type="text" id="university" v-model="university" required>
      
      <label for="hourly">Hourly Rate:</label>
      <input type="number" id="hourly" v-model="hourly" required>
      
      <button type="submit">Submit</button>
    </form>
  </div>
</template>

<script>
const API_BASE = process?.env?.VUE_APP_API_BASE_URL ?? '/api';

export default {
  name: 'AddCounselorView',
  data() {
    return {
      name: '',
      university: '',
      hourly: 0
    };
  },
  methods: {
    submitForm() {
      const counselorData = {
        name: this.name,
        university: this.university,
        hourly: this.hourly
      };
      console.log(counselorData);
      // Send POST request to /add-counselor
      fetch(`${API_BASE}/add-counselor`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(counselorData)
      })
      .then(response => response.json())
      .then(data => {
        // Handle response data
        console.log(data);
      })
      .catch(error => {
        // Handle error
        console.error(error);
      });
    }
  }
};
</script>

<style scoped>
/* Add your custom styles here */
</style>
